import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IBestPlace, IBestPlaceInitialState } from "./bestPlaceModal";
import {
  ActiveInactiveBestPlace,
  BestPlaceImageUpload,
  createBestPlace,
  deleteBestPlace,
  getAllActiveBestPlaces,
  getAllBestPlaces,
  getBestPlaceByID,
  updateBestPlace,
} from "./services/bestPlace.services";

const initialState: IBestPlaceInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  BestPlaceID: null,
  BestPlaceList: [],
  BestPlaceDetail: {
    Title: "",
    Image: "",
    IsActive: 1,
  },
};

const bestplaceSlice = createSlice({
  name: "bestplace",
  initialState,
  reducers: {
    clearBestPlaceDetails: (state) => {
      state.BestPlaceDetail = initialState.BestPlaceDetail;
    },
    setBestPlaceID: (state, action) => {
      state.BestPlaceID = action.payload;
    },
    clearBestPlaceID: (state) => {
      state.BestPlaceID = initialState.BestPlaceID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllBestPlaces.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllBestPlaces.fulfilled,
      (state, action: PayloadAction<IBestPlace[]>) => {
        state.loading = false;
        state.BestPlaceList = action.payload || [];
      }
    );
    builder.addCase(getAllBestPlaces.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.BestPlaceList = [];
    });
    builder.addCase(createBestPlace.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createBestPlace.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createBestPlace.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateBestPlace.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(updateBestPlace.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateBestPlace.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteBestPlace.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteBestPlace.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteBestPlace.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getBestPlaceByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getBestPlaceByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.BestPlaceDetail = action.payload;
    });
    builder.addCase(getBestPlaceByID.rejected, (state, action) => {
      state.formLoading = false;
      state.BestPlaceDetail = initialState.BestPlaceDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveBestPlaces.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveBestPlaces.fulfilled,
      (state, action: PayloadAction<IBestPlace[]>) => {
        state.loading = false;
        state.BestPlaceList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveBestPlaces.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.BestPlaceList = [];
    });
    builder.addCase(ActiveInactiveBestPlace.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveBestPlace.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveBestPlace.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(BestPlaceImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(BestPlaceImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(BestPlaceImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearBestPlaceDetails, clearBestPlaceID, setBestPlaceID } =
  bestplaceSlice.actions;
export default bestplaceSlice.reducer;
